import React from 'react';
import { Typography } from '@material-ui/core';

import { Tooltip } from 'components/Tooltip';


export function Section(props: {
  children: React.ReactNode,
  title?: string,
  tooltip?: string,
}) {
  return (
    <div className="bg-white d-flex section container" style={{padding: '15px', margin: '10px auto'}}>
      <div className='w-100 px-2 py-1'>
        {props.title &&
          <Typography variant='h2' className='mb-3 font-weight-bold'>
            {props.title}
            {props.tooltip && <Tooltip title={props.tooltip}/>}
          </Typography>
        }

        {props.children}
      </div>
    </div>
  );
}